module.exports = __webpack_public_path__ + "img/pexels-pixabay-160599.29cd62f6.jpg";